import { FormControl, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';



import { Injectable } from '@angular/core';
import { ValidatorService } from '../../../service/app/validator.service';

@Injectable()
export class AllValidatosService {

  constructor(public validatorService: ValidatorService) {

  }

  /*postalcode(control: AbstractControl): Promise<any> | Observable<any>
  {
    
    return this.validatorService.postalCode(control.value)
      .then(result => {
        //console.log(result);
        return result;
      })
  }*/

}



// WEBPACK FOOTER //
// ./src/app/core/component/core/validatos/all.validatos.ts